<template lang="pug">
div
    v-layout(row wrap v-show="formLoading")
        v-flex( xs12 text-xs-center elevation-4 pa-4  )
                    v-progress-circular( indeterminate color="primary" )
                    span.body-2.ml-3 Cargando datos...
    v-layout(row wrap v-show="!formLoading")
        v-flex(md12)
            v-breadcrumbs.pt-3( divider=">")
                v-breadcrumbs-item( @click='routerToProvider' ) Proveedor 
                v-breadcrumbs-item( disabled ) Información producto
        v-flex(md12)
            CrudForm(v-bind="staticData" :fields="myFields" :customRules="customRules" @submitForm="handleSubmit($event)" @autocompleteObjSelectId="callSubfamily($event)" noButtons)
</template>

<script>
import CrudForm from '@/components/reusable_components/CrudForm/CrudForm'
import PurchaseOrders from '@/components/Items/PurchaseOrders.vue'
import InputValidations from '@/mixins/InputValidations.js'
import CurrencyUtils from '@/mixins/CurrencyUtils.js'
// import WholesaleDiscountRoute from '@/mixins/WholesaleDiscountRoute'
import RUTInput from '@/components/reusable_components/RUTInput/RUTInput'
import FamilyService from '@/services/api/family/FamilyServices' //TODO: delete final s 
import SubfamilyService from '@/services/api/subfamily/SubfamilyService'
import CustomerService from '@/services/api/customer/CustomerService'
import TagService from '@/services/api/tag/TagServices'
import UnitMeasurementService from '@/services/api/unitMeasurement/UnitMeasurementService'
import ItemService from '@/services/api/item/ItemService'
import ProductService from '@/services/api/product/ProductService'
import CrudCreateButton from '@/components/reusable_components/CrudCreateButton/CrudCreateButton'
import ProviderProductsFields from '@/views/provider/form/ProviderProductsFields'
import {mapActions} from 'vuex'
export default {
    name: 'component-name',
    props: {},
    data: function() {
        return {
            formData: {},
            form: null,
            fields: ProviderProductsFields,
            staticData: null,

            customRules: {
                minLength8: function(value) {
                    return value.length >= 8 ? true : 'El largo mínimo es 8'
                },
            },
            formLoading:false,

        }
    },
    computed: {
        myFields() {
            return this.fields
        },
    },
    methods: {
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        fillStaticFormData() {
            let information = {}
            information.toolbarTitle = 'Producto'
            information.toolbarIcon = 'close'
            information.editable = false
            information.disabled = true
            information.submitText = 'Detalles producto'

            return information
        },
        async callSubfamily(event){
            if(event.type=="family"){
                let subFamily = await SubfamilyService.fetchAllSubfamilyByFamilyId(event.id)
                this.fields[6].options.data = subFamily
                this.myFields = JSON.parse(JSON.stringify(this.fields))
            }
        
        },
        async fillFields(){
            let product = await ProductService.fetchProduct(this.$route.params.id)
            let family = await FamilyService.fetchAllFamily()
            let subfamilySelected = await SubfamilyService.fetchSubfamily(product.wh_subfamily_id)
            let subfamily =await SubfamilyService.fetchAllSubfamily()
            let tags = await TagService.fetchAllTags()
            let tagSelected=product.wh_tags.map(tag=>{
                return tag.id
            })

            let unitMeasurement = await UnitMeasurementService.fetchAllUnitMeasurement()

            this.fields[9].options.data = tags

            let upcCodes = []
            let upcValues = []
            for(let i = 0; i < product.upc_codes.length; i++){
                // let currentUpc = {text: product.upc_codes[i], value: i }
                let currentUpc = {upc_code: product.upc_codes[i], index: i }
                upcCodes.push(currentUpc)
                upcValues.push(i)
            }
            this.fields[3].options.data = upcCodes
            
            for(let i = 0; i < family.length; i++){
                if(family[i].id === subfamilySelected.wh_family_id){
                    family = family[i].family
                    break
                }
            }
            

            this.fields[0].value = product.name
            this.fields[1].value = product.alias_name
            this.fields[2].value = product.description
            this.fields[3].value = upcValues
            this.fields[4].value = product.internal_code
            this.fields[5].value = family
            this.fields[6].value = subfamilySelected.subfamily
            this.fields[7].value = product.warranty_days
            this.fields[8].value = product.sale_prices.length>=1 ? product.sale_prices[0].sale_price : 0
            this.fields[9].value = tagSelected
            this.fields[10].value = product.wh_item.wh_unit_of_measurement_id
            this.fields[11].value = parseInt(product.wh_item.uom_quantity)
            this.fields[12].value = (product.wh_item.cost_price )
            this.fields[13].value = parseInt(product.wh_item.minimum_stock)
            this.fields[14].value = product.is_salable
            this.fields[15].value = product.wh_item.is_inventoriable
            this.fields[16].value = product.is_repackaged
            this.fields[17].value = product.is_consumable
            this.fields[18].value = product.wh_item.have_decimal_quantity
            this.fields[19].value = product.is_seasonal
            this.fields[20].value = product.is_tax_free
            this.fields = JSON.parse(JSON.stringify(this.fields))

        },
        /**
         * 
         */
        routerToProvider(){
            const route = `/providers/${this.$route.params.idProvider}`
            this.$router.push( route )
        },
        /**
         * 
         */
        setFormLoading ( formLoading ) {
            this.formLoading = formLoading
        },

    },
    watch: {},
    components: { CrudForm, RUTInput, CrudCreateButton, 'purchase-orders-list': PurchaseOrders },
    mixins: [InputValidations, CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    beforeMount: async function() {
        this.setFormLoading( true )
        this.staticData = this.fillStaticFormData()
        await this.fillFields()
        this.setFormLoading( false )
        
    },
    mounted: function(){
        this.setTitleTopBar('Información Producto')
    }
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
    
</style>